<template>
  <li
    v-if="canViewHorizontalNavMenuHeaderGroup(item)"
    class="dropdown nav-item"
    :class="{
      'sidebar-group-active active open': isActive,
      'show': isOpen,
    }"
    @mouseenter="() => updateGroupOpen(true)"
    @mouseleave="() => updateGroupOpen(false)"
  >
    <b-link class="nav-link dropdown-toggle d-flex align-items-center">
      <feather-icon
        size="14"
        :icon="item.icon"
      />
      <span>{{ t(item.header) }}</span>
    </b-link>
    <ul class="dropdown-menu">
      <component
        :is="resolvePublicNavMenuItemComponent(child)"
        v-for="child in item.children"
        :key="child.title"
        :item="child"
      />
    </ul>
  </li>
</template>

<script>
import { BLink } from 'bootstrap-vue'
import { resolvePublicNavMenuItemComponent } from '@core/layouts/utils'
import { useUtils as useAclUtils } from '@core/libs/acl'
import { useUtils as useI18nUtils } from '@core/libs/i18n'
import usePublicNavMenuHeaderGroup from './usePublicNavMenuHeaderGroup'
import mixinPublicNavMenuHeaderGroup from './mixinPublicNavMenuHeaderGroup'

import PublicNavMenuGroup from '../public-nav-menu-group/PublicNavMenuGroup.vue'
import PublicNavMenuLink from '../public-nav-menu-link/PublicNavMenuLink.vue'

export default {
  components: {
    BLink,
    PublicNavMenuGroup,
    PublicNavMenuLink
  },
  mixins: [mixinPublicNavMenuHeaderGroup],
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  setup (props) {
    const {
      isActive,
      updateIsActive,
      isOpen,
      updateGroupOpen
    } = usePublicNavMenuHeaderGroup(props.item)

    const { t } = useI18nUtils()
    const { canViewHorizontalNavMenuHeaderGroup } = useAclUtils()

    return {
      isOpen,
      isActive,
      updateGroupOpen,
      updateIsActive,
      resolvePublicNavMenuItemComponent,

      // ACL
      canViewHorizontalNavMenuHeaderGroup,

      // i18n
      t
    }
  }
}
</script>
